export default __webpack_public_path__ + "static/media/tier-three-monster.f9446f12.png";